import { type OverridesType } from '@atlaskit/drawer';
import { token } from '@atlaskit/tokens';

const MOBILE_BREAKPOINT = 500;

export const getDrawerStyleOverrides = (
	shouldShowExperimentHeader: boolean | undefined,
): OverridesType => {
	return {
		Sidebar: {
			cssFn: () =>
				shouldShowExperimentHeader
					? {
							display: 'none',
						}
					: {
							top: token('space.150', '12px'),
							left: token('space.150', '12px'),
							position: 'absolute',
							[`@media (max-width: ${MOBILE_BREAKPOINT}px)`]: {
								top: token('space.050', '4px'),
								width: 52,
							},
						},
		},
		Content: {
			cssFn: (defaultStyles) => ({
				...defaultStyles,
				overflow: shouldShowExperimentHeader ? 'unset' : defaultStyles.overflow,
				marginTop: 0,
				[`@media (max-width: ${MOBILE_BREAKPOINT}px)`]: {
					marginTop: token('space.600', '48px'),
				},
			}),
		},
	};
};
